import { useRoute } from '@nuxtjs/composition-api';
import { RouteName } from '@shared/types/RouteName';

const isRouteInList = (list: string[], path: string) =>
  list.some((route) => path.split('/').includes(route));

interface Config {
  whitelistedRoutes?: RouteName[];
  blacklistedRoutes?: RouteName[];
}

const useRouteExclusion = () => {
  const route = useRoute();
  const path = route.value.path;

  const isStringInPath = (route: RouteName) => {
    return isRouteInList([route], path);
  };

  const isExcluded = (config: Config | RouteName[]) => {
    if (Array.isArray(config)) {
      return !isRouteInList(config, path);
    }
    if (config.whitelistedRoutes?.length) {
      return !isRouteInList(config.whitelistedRoutes, path);
    }
    if (config.blacklistedRoutes?.length) {
      return isRouteInList(config.blacklistedRoutes, path);
    }
    return true;
  };

  return {
    isStringInPath,
    isExcluded,
  };
};

export default useRouteExclusion;
